// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"c1997039","693":"0892ca0f"}[chunkId] + ".chunk.js";
};